"use strict";
const DEFAULT_DURATION_DAYS = 30;
const DEFAULT_DURATION_SECONDS = DEFAULT_DURATION_DAYS * 24 * 60 * 60;
export { DEFAULT_DURATION_DAYS, DEFAULT_DURATION_SECONDS };
